import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { UserPermissionsEnum } from '../core/enums/user-permissions.enum';
import { CompanyInterface } from '../core/models/company.model';
import { PermissionsService } from '../core/services/permissions/permissions.service';
import { UserService } from '../core/services/user/user.service';
import { SharedModule } from '../shared/shared.module';
import { TooltipGlobalOpenerDirective } from '../ui-elements/tooltip/tooltip-global-opener.directive';
import { CompanyInformationComponent } from './company-information/company-information.component';

@Component({
  selector: 'app-company-account',
  imports: [SharedModule, TooltipGlobalOpenerDirective, CompanyInformationComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './company-account.component.html',
})
export class CompanyAccountComponent implements OnInit {
  private userService = inject(UserService);
  private permissionsService = inject(PermissionsService);

  activeTab: 'agreement' | 'information' = 'agreement';
  company: CompanyInterface;
  hasPermissionToViewPurchaseAndSalesAgreement = true;
  hasPermissionToViewCompanyInformation = true;

  ngOnInit(): void {
    this.userService.getUserCompany().subscribe((company) => {
      this.company = company;
    });

    this.hasPermissionToViewPurchaseAndSalesAgreement = this.permissionsService.hasPermission(
      UserPermissionsEnum.VIEW_PURCHASE_AND_SALES_AGREEMENT,
    );
    this.hasPermissionToViewCompanyInformation = this.permissionsService.hasPermission(UserPermissionsEnum.VIEW_COMPANY_INFO);

    this.activeTab = this.hasPermissionToViewPurchaseAndSalesAgreement ? 'agreement' : 'information';
  }

  get agreementTabActive(): boolean {
    return this.activeTab === 'agreement';
  }

  get currencyName(): string {
    return this.company.priceList.currency?.name;
  }

  getPaymentScheduleTooltipContent(): string {
    const validSuffixes = [
      'P001',
      'P003',
      'P005',
      'P007',
      'P010',
      'P014',
      'P015',
      'P015-L',
      'P020',
      'P021',
      'P025',
      'P025-L',
      'P028',
      'P030',
      'P030-L',
      'P035',
      'P035-F',
      'P040',
      'P045',
      'P045-10',
      'P055',
      'P060',
      'P060-T',
      'P065',
      'P075',
      'P090',
      'PP00',
      'PP20-60',
      'PP30-30',
      'PP50-30',
      'PP50-60',
      'PP50-90',
    ];

    return validSuffixes.includes(this.company.paymentSchedule) ? `PAYMENT_SCHEDULE_TOOLTIP.${this.company.paymentSchedule}` : '';
  }

  getMethodOfDeliveryTooltipContent(): string {
    const validSuffixes = ['LO', 'PL', 'PL-F', 'PL-F-JAV', 'PL-F-JAV-D', 'PL-SO', 'SPEC'];

    return validSuffixes.includes(this.company.delivery?.method)
      ? `METHOD_OF_LOADING_AND_DELIVERING_TOOLTIP.${this.company.delivery.method}`
      : '';
  }
}
